import React from 'react';
import PropTypes from 'prop-types';

const Pet = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      d="M6.5 9.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM11 5.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65S7.997 2.5 9 2.5c1.003 0 2 1.073 2 2.65ZM17 5.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM21.5 9.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM16.96 14.184l.013.016.014.014.238.237c.594.59 1.178 1.17 1.613 1.815.477.706.741 1.443.622 2.287-.26.88-.88 1.699-1.94 1.937-.105.019-.318.017-.677-.017-.293-.029-.64-.074-1.04-.126l-.232-.03c-.985-.128-2.216-.277-3.49-.277h-.18c-1.277 0-2.508.152-3.492.28l-.206.028c-.41.053-.766.1-1.065.129-.362.034-.573.034-.674.014-1.064-.238-1.683-1.05-1.944-1.936-.114-.839.152-1.574.63-2.28.436-.643 1.02-1.223 1.613-1.812l.24-.24.014-.013.012-.013c.565-.655 1.07-1.25 1.588-1.861l.892-1.05c.454-.521.962-.977 1.533-1.173l.009-.003c.085-.03.168-.053.249-.068l.005-.001c.205-.04.427-.041.695-.041.266 0 .493.001.696.033.08.015.16.037.243.067l.009.003c.573.197 1.092.655 1.531 1.171l.003.003c.563.652 1.063 1.241 1.579 1.85.29.341.585.69.899 1.057Z"
    />
  </svg>
);

Pet.propTypes = {
  color: PropTypes.string
};

export default Pet;
